import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchBar } from "@/components/site/SearchBar";
import { PropertyCard } from "@/components/site/PropertyCard";
import { MaskLine, Eyebrow } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";
import { useLang } from "@/lib/i18n";
import { api } from "@/lib/site";

export const PageHero = ({ img, eyebrow, title }) => (
  <section className="relative h-[60svh] min-h-[420px] bg-midnight overflow-hidden flex items-end">
    <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60 kenburns" />
    <div className="absolute inset-0 bg-gradient-to-t from-midnight via-midnight/30 to-midnight/50" />
    <div className="relative max-w-[1400px] w-full mx-auto px-6 lg:px-12 pb-16">
      <Eyebrow className="text-gold mb-6">{eyebrow}</Eyebrow>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl text-ivory leading-[1.05]"><MaskLine animateNow delay={0.2}>{title}</MaskLine></h1>
    </div>
  </section>
);

export default function Properties() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [items, setItems] = useState(null);
  const initial = Object.fromEntries(params.entries());
  useEffect(() => {
    setItems(null);
    api.get(`/properties?${params.toString()}`).then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, [params]);
  return (
    <main data-testid="properties-page">
      <Seo title={t.nav.properties} path="/nehnutelnosti" />
      <PageHero img="/img/p2.jpg" eyebrow="MEVALUX PROPERTY" title={t.nav.properties} />
      <section className="bg-ivory py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <SearchBar key={params.toString()} initial={initial} />
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="properties-grid">
            {items?.map((p, i) => <PropertyCard key={p.id} p={p} i={i} />)}
          </div>
          {items && !items.length && <p className="font-display italic text-2xl text-midnight/70 mt-10" data-testid="no-results">{t.noResults}</p>}
        </div>
      </section>
    </main>
  );
}
